import React from 'react';

interface SkeletonProps {
  className?: string;
  width?: string;
  height?: string;
}

/**
 * Simple, reusable skeleton loader with pulse animation
 */
export function Skeleton({ className = '', width = 'w-full', height = 'h-4' }: SkeletonProps) {
  return (
    <div 
      className={`animate-pulse bg-slate-200 dark:bg-slate-700 rounded ${width} ${height} ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
}

/**
 * Skeleton specifically for EmployeeShiftInfo table layout
 */
export function EmployeeShiftSkeleton() {
  return (
    <div className="rounded-md border border-slate-200 dark:border-slate-600 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full min-w-max">
          <thead>
            <tr className="bg-slate-100/60 dark:bg-slate-700/40 border-b border-slate-200 dark:border-slate-600">
              <th className="px-3 py-2 text-left text-xs font-medium text-slate-700 dark:text-slate-300">Shift Name</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-slate-700 dark:text-slate-300">Shift Timing</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-slate-700 dark:text-slate-300">Total Duration</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-slate-700 dark:text-slate-300">Break Deduction</th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-white dark:bg-slate-800/50">
              <td className="px-3 py-3">
                <Skeleton width="w-20" height="h-6" />
              </td>
              <td className="px-3 py-3">
                <Skeleton width="w-24" height="h-5" />
              </td>
              <td className="px-3 py-3">
                <Skeleton width="w-16" height="h-5" />
              </td>
              <td className="px-3 py-3">
                <Skeleton width="w-18" height="h-5" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
